<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
      
         <z-page title="Daftar : Bil Pelbagai">

            <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitInbois" @success="onSuccess">
            <div class="message-box">
              <w-transition-fade>
                <w-alert
                  class="my0 text-light"
                  v-if="form.submitted"
                  success
                  no-border>
                  The form is valid, ready to send it!
                </w-alert>

                <w-alert
                  class="my0 text-light"
                  v-else-if="form.valid === false"
                  error
                  no-border>
                  Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                </w-alert>
              </w-transition-fade>
            </div>


            <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                     Tambah Profil
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submitProfil" @success="success">
                        <template ></template><br>

                        <w-flex justify-space-between class="mb4">
                            <div class="xs4">
                           <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            </div>

                           </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. KP/No. Syarikat *"  
                              name="No. ID" 
                              v-model="form_profil.no_id" 
                              :validators="[validators.required]"/>
                            <z-input 
                              label="Nama *" 
                              name="Nama" 
                              v-model="form_profil.nama" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Alamat" 
                              name="Alamat" 
                              v-model="form_profil.alamat1"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat2" 
                              v-model="form_profil.alamat2" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat3" 
                              v-model="form_profil.alamat3" />
                        </w-flex>
                        <z-lookup 
                              label="Poskod" 
                              name="poskod" 
                              :url='service_bil_pelbagai+"lookup/lkp_poskod"' 
                              :sort="false" :cache="false"
                              v-model="form_profil.lkp_poskod_id"/><br>
                            <w-flex justify-center align-center>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.bandar}}</td>
                                  </tr>
                              </div>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.negeri}}</td>
                                  </tr>
                              </div>
                            </w-flex><br>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. Telefon" 
                              name="No. Telefon" 
                              v-model="form_profil.no_tel" 
                              :validators="[validators.numeric]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Emel"  
                              name="Email" 
                              v-model="form_profil.emel"/>
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                    <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">Simpan</w-button>
                </template>
            </w-dialog>

          <w-card bg-color="" class="">

          <h3>Tambah Profil</h3><br><br>
              
                <w-flex class="mt3">

                    <z-input label="Profil *"  name="profil_id" readonly @click="profil" :validators="[validators.required]"/>
                    
                    <div class="xs1">
                        <!-- <w-icon>fal fa-search</w-icon> -->
                        &nbsp;
                        <w-icon  @click="dialog.show = true">fal fa-plus</w-icon>
                    </div>
                </w-flex>
                 
              <br>
               <w-flex justify-center align-center v-if="form.no_id">
                    <div class="xs6">
                      <h5 class="fw-semibold m0">
                          Profil :
                      </h5>
                      {{form.no_id.toUpperCase()}} | {{form.nama.toUpperCase()}}
                    </div>

                    <div class="xs6">
                      <h5 class="fw-semibold m0">
                          Alamat :
                        </h5>
                        <span >
                            <template v-if="form.alamat1"> 
                                {{form.alamat1.toUpperCase()}} 123, 
                            </template>
                            <template v-if="form.alamat2"> 
                                {{form.alamat2.toUpperCase()}} , 
                            </template>
                            <template v-if="form.alamat3"> 
                                {{form.alamat3.toUpperCase()}} , 
                            </template>
                            <template v-if="form.poskod"> 
                                {{form.poskod.toUpperCase()}} ,
                            </template> 
                            <template v-if="form.bandar"> 
                                {{form.bandar.toUpperCase()}} , 
                            </template>
                            <template v-if="form.negeri"> 
                                {{form.negeri.toUpperCase()}}
                            </template>
                        </span>
                    </div>
              </w-flex>
                  <w-flex justify-center align-center v-else>
                        <div class="xs6">
                              <h5 class="fw-semibold m0">
                                  Profil :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{form.profil ? form.profil.no_id : ''}} 
                              <template v-if="form.id >= 1">|</template>
                               {{form.profil ? form.profil.nama: ''}}</div>
                        </div>
                        <div class="xs6">
                              <h5 class="fw-semibold m0">
                                  Alamat :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat1 : '' : ''}} 
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat2 : '' : ''}}
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat3 : '' : ''}}
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_poskod.keterangan : '' : ''}}
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_poskod.bandar : '' : ''}}
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_negeri.keterangan : '' : ''}}  
                              </div>
                         </div>
                    </w-flex>
                
                 
        </w-card><br>

          <w-flex justify-center align-center class="mt5">
              <div class="w-card__content content-hardcode">                
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td>Kod Akaun</td>
                            <td>Vot</td>
                            <td>No Fail</td>
                            <td>Butiran</td>
                            <td>Kuantiti</td>
                            <td>Kadar (RM)</td>
                            <td>Amaun (RM)</td>
                            <td> <w-icon class="mr1" @click="addItem">fal fa-plus</w-icon></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dt, index in form.butiran">
                            <td >
                                 <z-lookup name="akaun" :url='service_bil_pelbagai+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="dt.akaun_id" @pilih="Vot_akaun(dt)" :validators="[validators.required]"/>
                            </td>
                            <td>
                               <template v-if="dt.vot_id">
                                    <template v-if="dt.ind_vot_id">
                                       <z-lookup name="vot" :url='service_bil_pelbagai+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id" :validators="[validators.required]" />
                                   </template>
                                   <template v-else>
                                       <z-lookup name="vot" :url='service_bil_pelbagai+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  :validators="[validators.required]"/>
                                   </template>
                               </template>
                               <template v-else>
                                   <z-lookup name="vot" :url='service_bil_pelbagai+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id" :validators="[validators.required]" />
                               </template>
                                
                                
                            </td>
                               
                            <td>
                              <w-input v-model="dt.no_fail" /> 
                            </td>
                            <td>
                              <w-input v-model="dt.keterangan" required :validators="[validators.required]" /> 
                            </td>
                            <td>
                                <w-input class="mb4" type="number" v-model="dt.kuantiti" v-on:keyup="cekJumlah(dt)"  :validators="[validators.required]" />
                            </td>
                            <td>
                                <!-- <w-input class="mb4" label="Kadar *" type="number" v-model:originalValue="dt.kadar" v-on:keyup="cekJumlah(dt)"  :validators="[validators.required]" /> -->

                                <z-money v-model:originalValue="dt.kadar" v-on:keyup="cekJumlah(dt)"  :validators="[validators.required]"/>
                            </td>
                            <td align="right">
                                <!-- <w-input class="mb4" label="Amaun *" type="number" v-model="dt.amaun" v-on:keyup="cekAmaun()" :validators="[validators.required]"  /> -->
                                {{$zutil.currency(dt.amaun)}}
                            </td>
                            <td><w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon></td>
                        </tr>
                        <tr >
                          <td colspan="6"><b>Jumlah</b></td>
                          <td align="right"><b>{{$zutil.currency(form.amaun)}}</b></td>
                          <!-- <td>{{$zutil.currency(form.kuantiti)}}</td> -->
                        </tr>
                        
                        
                    </tbody>
                </table>
              </div>

            </w-flex>

             <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                <template v-if="form.lkp_inbois_status_id == 1 && $zutil.can('BilPelbagai Batalkan')">
                    <w-button class="my1" bg-color="error-dark1" dark  @click="send(4)">
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                    </w-button>
                    &nbsp;&nbsp;
                </template>

                <template v-if="form.amaun != null">
                <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.loading && !form.sent" >
                    <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
                </w-button>
              </template>
                <!-- <template v-if="(form.lkp_inbois_status_id == 1 ) && $zutil.can('BilPelbagai Penyediaan')"> -->
                  <template v-if="form.lkp_inbois_status_id == 1 && $zutil.can('BilPelbagai Penyediaan')">
                    &nbsp;&nbsp;&nbsp;
                    <w-button class="my1" @click="send(2)" type="button" >
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Hantar
                    </w-button>
                </template>

            </w-flex>
              
      
        </w-form>
         <w-dialog
              v-model="dialogProfil.show"
              :fullscreen="dialogProfil.fullscreen"
              :width="dialogProfil.width"
              :persistent="dialogProfil.persistent"
              :persistent-no-animation="dialogProfil.persistentNoAnimation"
              title-class="primary-light1--bg white">
              <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil
              </template>
              <div class="page-wrapper-portal">
                  <w-flex justify-center align-center>
                      <div class="xs8">
                             <w-input label="No KP | Nama (Carian minimun 2 aksara)" v-model="carian_profil.q" > </w-input>
                      </div>
                      <div class="xs4">
                            <w-button class="ml1" @click="cariProfil">Cari</w-button>
                      </div>
                  </w-flex>
                  <div class="table-profil-scrol">
                  <table class="w-table ">
                      <thead>
                      <tr>
                          <th class="w-table__header w-table__header--sortable text-left">No</th>
                          <th class="w-table__header w-table__header--sortable text-left">No KP | Nama</th>
                          <th class="w-table__header w-table__header--sortable text-left">Pilih</th>
                      </tr>
                      </thead>
                      <tbody>
                      
                          <tr v-for="dt, index in profils">
                              <td class="w-table__cell text-left">
                                  {{(index+1)}}
                              </td>
                              <td class="w-table__cell ">
                                  {{dt.label.toUpperCase()}}
                              </td>
                              <td class="w-table__cell text-right">
                                  <w-radio class="mr2" v-model="form.profil_id" :return-value="dt.value" @click="pilihProfil(dt)"></w-radio>
                              </td>
                          </tr>
                          
                      </tbody>
                      
                  </table>
                </div>
              </div>

                <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="dialogProfil.show = false">Tutup</w-button>
                </template>
          </w-dialog>
      </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'
// import moment from 'moment'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
        resourceurl: this.service_bil_pelbagai+'inbois',
        reload: true,
        // akaun_id : '',
        form_profil :{},
        dt_akaun :{},
        dt_vot :{},
        form :{},
        hantar : {},
        kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],

        form_cari : {},
        carian_profil : {q: ''},
        profils : [],
        vot_ids : [],
        akauns : [],
        dialogProfil: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
        },

        form : {
          loading: false,
            // vot_id : '',
        },
        validators: {
                unique: (value) => !!value || "Medan Ini Wajib Isi",
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Bil Pelbagai', route: '/inbois' },
            { label: 'Daftar ', route: '/inbois/daftar' }
          ],
          }
  },
  methods: {

    addItem() {
        this.form.butiran.push( {akaun_id : null, vot_id : null, no_fail : null, keterangan : null, kuantiti : 1, kadar : null, amaun : null, lama_vot_id : null});
    },

     removeItem(index) {
        this.form.butiran.splice(index, 1);
    },

     cekAmaun(){
      this.form.amaun = 0;
      for (var i in this.form.butiran) {
        this.form.amaun = this.form.amaun + parseFloat(this.form.butiran[i].amaun);
        }
    },

    cekJumlah(dt){
      dt.amaun = dt.kuantiti * dt.kadar
      this.cekAmaun();
      // for (var i in this.form.butiran) {
        // }
    },

    send(status){

      this.form.loading = true
      this.hantar.id = this.form.id
      this.hantar.lkp_inbois_status_id = status
      this.hantar.profil_id = this.form.profil_id
      this.hantar.butiran = this.form.butiran
      this.$zcomm.update(this.resourceurl + '/'+this.hantar.id, this.hantar.id, this.hantar)
                  .then(res => {
                    // this.bil_id = res.id;
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                                  this.$zutil.notify ("Rekod telah berjaya dihantar")
                                  // this.$inertia.visit(this.$route('inbois.show', res.id))
                      // this.$inertia.visit(this.$route('inbois.index'))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                     this.form.loading = false;
                    this.$inertia.visit(this.$route('inbois.show', this.form.id))

                  });
    
    },


    submitInbois(){
     // alert('asssd');
        if (this.form.id > 0) {

            if (this.form.valid == true) {
                this.form.loading = true
                // this.form.valid = false
              this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                     this.form.loading = false;
                  });
              }
          }else {

            if (this.form.valid == true && this.form.profil_id !=null ) {
                // this.form.valid = false
                this.form.loading = true
                this.$zcomm.post(this.resourceurl, this.form)
                  .then(res => {
                                  if (typeof this.onAfterAdd === "function") {
                                      this.onAfterAdd()
                                  }
                                  this.$zutil.notify ("Rekod telah berjaya simpan")
                                  this.$inertia.visit(this.$route('inbois.semak', res.id))

                                })
                                .catch(err => {

                                })
                                .finally(() => {
                                 this.form.loading = false;

                                });
                        }
              }
    },

    // onSuccess(){
    //      if (this.form.id > 0) {
    //           this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
    //               .then(res => {
                      

    //                 if (typeof this.onAfterEdit === "function") {
    //                     this.onAfterEdit()
    //                   }
    //               })
    //               .catch(err => {

    //               })
    //               .finally(() => {
                      

    //               });
    //       }
          // else {
          //     this.$zcomm.post(this.resourceurl , this.form)
          //         .then(res => {
                    
                    
          //           if (typeof this.onAfterAdd === "function") {
          //             this.onAfterAdd()
          //           }
          //             this.$inertia.visit(this.$route('inbois.semak', res.id))
                    
          //         })
          //         .finally(() => {
                      

          //           // $('#' + this.resourceurl).modal('hide')
          //         });
          // }
    
    // },


    
     profil(){
      this.dialogProfil.show = 1
    },

   
    cariProfil(){
      if(this.carian_profil.q.length > 1){
        this.$zcomm.post(this.service_bil_pelbagai+"lookup/profil", this.carian_profil, {})
        .then(res => {
          console.log(res)
            this.profils = res
          })
      }
    },

    pilihProfil(dt){
      this.form.profil_keterangan = dt.label;
      this.form_cari.id = dt.value;
      this.profilDetail();
    },

    getAkauns() {
      
    this.$zcomm.get(this.service_bil_pelbagai+'lookup/akaun_akhir').then(res => {
              this.akauns = res;
            });
    },

    poskodDetail() {
      
    this.$zcomm.get(this.service_bil_pelbagai+'lookup/lkp_poskod_detail/'+this.form_profil.lkp_poskod_id).then(res => {
              this.form_profil.negeri = res.negeri;
              this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
              this.form_profil.bandar = res.bandar;
              this.form_profil.lkp_jenis_alamat_id = 1;
            });
    },

    getVots(){
       this.$zcomm.get(this.service_bil_pelbagai+'lookup/vot').then(res => {
              this.vots = res;
            });
    },
    Vot_akaun(dt){
        
        if(dt.ind_vot_id == 0){
            dt.ind_vot_id = 1
        }else{
            dt.ind_vot_id = 0
        }
        for (var a in this.akauns) {
            if(dt.akaun_id == this.akauns[a].value){
                dt.vot_id = this.akauns[a].vot;
            }
        }
        // dt.lama_vot_id = dt.vot_id;
      // this.Vots = [];
      // for (var i in form.butiran) {
      //   // for (var a in this.akauns) {
      //       if(this.form.butiran[i].akaun_id == this.dt.akaun_id){
      //         this.Vots.push(this.form.butiran[i].vot_id);
      //       // }

      //   }
      // }
        // for (var i in this.form.butiran) {
        //     for (var a in this.akauns) {
        //         if(this.form.butiran[i].akaun_id == this.akauns[a].value){
        //             this.akauns.push(this.form.butiran[i].vot_id = this.akauns[a].vot);
        //             // this.form.butiran[i].vot_id =  this.akauns[a].vot;
        //         }else{
        //             this.Vots.push(this.form.butiran[i].vot_id);
        //         }
        //       }
              
        //     }
        
    },
    // akaunDetail(dt) {
        
    // this.$zcomm.get(this.service_bil_pelbagai+'lookup/akaun_detail/'+dt.akaun_id).then(res => {
    //           dt.vot_id = res.id;
    //           dt.vot_kod = res.kod;
    //           dt.vot_keterangan = res.keterangan;
    //         });
    // },

     profilDetail() {
        // alert('w234')
      
      this.$zcomm.get(this.service_bil_pelbagai+'profil/'+this.form_cari.id).then(res => {
              this.form.profil_id = res.id;
              this.form.no_id = res.no_id;
              this.form.nama = res.nama;
              this.form.alamat1 = res.alamat1;
              this.form.alamat2 = res.alamat2;
              this.form.alamat3 = res.alamat3;
              this.form.poskod = res.poskod;
              this.form.bandar = res.bandar;
              this.form.negeri = res.negeri;
              this.form.kategori = res.kategori;
              
            });
      this.dialogProfil.show = false
    },
    
    submitProfil() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                
                    this.$zcomm.post(this.service_bil_pelbagai+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialog.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          this.form.profil_id = res.id;
                          this.form.no_id = res.no_id;
                          this.form.nama = res.nama;
                          this.form.alamat1 = res.alamat1;
                          this.form.alamat2 = res.alamat2;
                          this.form.alamat3 = res.alamat3;
                          this.form.poskod = res.poskod;
                          this.form.bandar = res.bandar;
                          this.form.negeri = res.negeri;
                          this.form.kategori = res.kategori;
                            // this.$inertia.visit(this.$page.url)
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;

                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },
    
  
    
  },
  watch: {
    'form_profil.lkp_poskod_id': function(q) {
            
                this.poskodDetail();
            
        },

       
    'form_cari.id': function(q) {
            
                this.profilDetail();
            
        },


    // 'form.butiran': {
    //       handler(butiran) {
    //         // console.log(oldValue)
    //         for (var i in this.form.butiran) {
    //             for (var a in this.akauns) {
    //             if(this.form.butiran[i].akaun_id == this.akauns[a].value){
    //               this.form.butiran[i].vot_id =  this.akauns[a].vot
    //                // if(this.form.butiran[i].vot_id =  this.akauns[a].vot){
    //                //      this.$zcomm.get(this.service_bil_pelbagai+'lookup/vot')
    //                //  }
    //               // this.getVot()
    //               }
    //           }
    //         }
             
    //         },
    //         deep: true
    //       }

          // 'form.butiran': {
          // handler(butiran) {
          //   // console.log(oldValue)
          //   for (var i in butiran) {
          //       if(butiran[i].akaun_id){
          //         this.akaunDetail(butiran[i])
          //         this.$zcomm.get(this.service_bil_pelbagai+'lookup/vot')
          //     }
          //   }
             
          //   },
          //   deep: true
          // }


      },

  mounted() {
    // this.listVot = this.$zcomm.get(this.service_bil_pelbagai+'lookup/vot');

    this.dialog.width = 900
    this.getAkauns();
    this.getVots();
    if(this.id == 0){
      this.form = {
        // vot_id : '',
        show: true,
        butiran : [{akaun_id : null, vot_id : null, no_fail : null, keterangan : null, kuantiti : 1, kadar : null, amaun : null} ]}
      }

  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
